var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"c-engine-chip white--text font-weight-bold",class:{ 'cursor-pointer': !!_vm.$listeners.click },style:({ background: _vm.color })},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }